<template>
    <!--sidebar-menu :menu="menu" /-->
    <aside class="menu-area">
        <nav class="menu">
            <router-link to="/">
                <i class="fa fa-home" title="Home"></i>
                <strong v-show="isMenuVisible"> Home</strong>
            </router-link>
            <div  v-if="user.tenant === 1">
                <router-link to="/tenantfinancial">
                    <i class="fa fa-folder-open-o" title="Financial Detailing"></i>
                    <strong v-show="isMenuVisible"> Financial Detailing</strong>
                </router-link>
                <router-link to="/tenantcontract">
                    <i class="fa fa-folder-open-o" title="Contract Detailing"></i>
                    <strong v-show="isMenuVisible"> Contract Detailing</strong>
                </router-link>
            </div>
             <div  v-if="user.parther === 1">
                 <router-link to="/businessopportunityopen">
                    <i class="fa fa-folder-open-o" title="Open Business Opportunity"></i>
                    <strong v-show="isMenuVisible"> Open Business Opportunity</strong>
                </router-link>
                <router-link to="/businessopportunityclosed">
                    <i class="fa fa-folder-open-o" title="Closed Business Opportunity"></i>
                    <strong v-show="isMenuVisible"> Closed Business Opportunity</strong>
                </router-link>
             </div>
            <div v-if="user.admin ===1" >
            <router-link to="/admin">
                <i class="fa fa-cogs" title="System Administration"></i
                ><strong v-show="isMenuVisible"> System Administration</strong>
            </router-link>
            
            <router-link to="/entitys">
                <i class="fa fa-street-view" title="Unified Registration"></i>
                <strong v-show="isMenuVisible"> Unified Registration</strong>
            </router-link>
             <router-link to="/registrationpages">
                <i class="fa fa-gear" title="Registration"></i>
                <strong v-show="isMenuVisible"> Registration</strong>
            </router-link>           
             <router-link to="/tasks">
                <i class="fa fa-tasks" title="Tasks"></i>
                <strong v-show="isMenuVisible"> Tasks</strong>
            </router-link>
            <router-link to="/dailyactivities">
                <i class="fa fa-archive" title="Daily Activities"></i>
                <strong v-show="isMenuVisible"> Daily Activities</strong>
            </router-link>
             <router-link to="/mytasks">
                <i class="fa fa-tasks" title="My Tasks"></i>
                <strong v-show="isMenuVisible"> My Tasks</strong>
            </router-link>
             <router-link to="/warningmessages">
                <i class="fa fa-comments" title="Warning Messages "></i>
                <strong v-show="isMenuVisible"> Warning Messages </strong>
                <b-badge pill title="Warning Messages "  variant="light">{{this.warningmessages.length}}</b-badge>
            </router-link>
            </div>

             <router-link to="/dailyactivitiesusers" v-if="user.service_provider === 1">
                <i class="fa fa-archive" title="Daily Activities"></i>
                <strong v-show="isMenuVisible"> Daily Activities</strong>
            </router-link>
            <router-link to="/dashproviderservice" v-if="user.service_provider === 1">
                <i class="fa fa-calendar-minus-o" title="My Services"></i>
                <strong v-show="isMenuVisible"> My Services</strong>
            </router-link>
            
             <b-button v-if="user.record_owner === 1" v-b-toggle.sidebar-1>
                <i
                    class="fa fa-indent"
                    title="Landlord"
                ></i>
                <strong v-show="isMenuVisible"> Landlord</strong>
            </b-button>

            <b-button v-if="user.record_tenant === 1" v-b-toggle.sidebar-2>
                <i
                    class="fa fa-indent"
                    title="Tenant"
                ></i>
                <strong v-show="isMenuVisible"> Tenant</strong>
            </b-button>

            <b-button v-if="user.record_service_provider === 1" v-b-toggle.sidebar-3>
                <i
                    class="fa fa-indent"
                    title="Service Provision"
                ></i>
                <strong v-show="isMenuVisible"> Service Provision</strong>
            </b-button>

             <b-button v-if="user.record_financial === 1" v-b-toggle.sidebar-4>
                <i
                    class="fa fa-indent"
                    title="Financial"
                ></i>
                <strong v-show="isMenuVisible"> Financial</strong>
            </b-button>

             <b-button v-if="user.record_parther === 1" v-b-toggle.sidebar-5>
                <i
                    class="fa fa-indent"
                    title="Parther"
                ></i>
                <strong v-show="isMenuVisible"> Parther</strong>
            </b-button>
          
        </nav>
        <b-sidebar id="sidebar-1" title="LandLord" shadow :backdrop-variant="dark" backdrop>
             <router-link to="/owners">
                <i class="fa fa-vcard" title="Record"></i>
                <strong > Record</strong>
            </router-link>
             <router-link to="/ownercontracts">
                <i class="fa fa-folder-open-o" title="Contract"></i>
                <strong > Contract</strong>
            </router-link>
        </b-sidebar>

        <b-sidebar id="sidebar-2" title="Tenants" shadow :backdrop-variant="dark" backdrop>
            <router-link to="/tenants">
                <i class="fa fa-vcard" title="Record"></i>
                <strong > Record</strong>
            </router-link>
            <router-link to="/tenantagreements">
                <i class="fa fa-folder-open-o" title="Contract/Agreement"></i>
                <strong > Contract/Agreement</strong>
            </router-link>
        </b-sidebar>

        <b-sidebar id="sidebar-3" title="Service Provision" shadow :backdrop-variant="dark" backdrop>
             <router-link to="/serviceproviders">
                <i class="fa fa-drivers-license-o" title="Service Provider"></i>
                <strong > Service Provider</strong>
            </router-link>
            <router-link to="/realstates">
                <i class="fa fa-vcard-o" title="Real State"></i>
                <strong > Real State</strong>
            </router-link>
            <router-link to="/serviceprovidercontracts">
                <i class="fa fa-sticky-note" title="Contract"></i>
                <strong > Contract</strong>
            </router-link>
              
             <router-link to="/servicecontracts">
                <i class="fa fa-sticky-note-o" title="Service Provision Contract"></i>
                <strong > Service Provision Contract</strong>
            </router-link>
             <router-link to="/openserviceorders">
                <i class="fa fa-ticket" title="Order Service"></i>
                <strong > Order Service</strong>
            </router-link>
            <router-link to="/servicerequests">
                <i class="fa fa-tag" title="Request"></i>
                <strong> Request</strong>
            </router-link>
        </b-sidebar>

         <b-sidebar id="sidebar-4" title="Financial" shadow :backdrop-variant="dark" backdrop>
             <router-link to="/operationslevelones">
                <i class="fa fa-bandcamp" title="Operation"></i>
                <strong > Operation </strong>
            </router-link>
            <router-link to="/financialcontrols">
                <i class="fa fa-google-wallet" title="Financial Control"></i>
                <strong > Financial Control</strong>
            </router-link>
            <router-link to="/invoices">
                <i class="fa fa-tag" title="Invoices"></i>
                <strong > Invoices</strong>
            </router-link>
         </b-sidebar>

          <b-sidebar id="sidebar-5" title="Parther" shadow :backdrop-variant="dark" backdrop>
                <router-link to="/parthers">
                    <i class="fa fa-vcard" title="Record"></i>
                    <strong > Record</strong>
                </router-link>
                <router-link to="/businessopportunitys">
                    <i class="fa fa-th-large" title="Business Opportunity"></i>
                    <strong > Business Opportunity</strong>
                </router-link>
          </b-sidebar>

    </aside>
</template>

<script>
import { mapState } from 'vuex'
import { baseApiUrl } from '@/global'
import axios from 'axios'

export default {
    name: 'Menu',
     data: function() {
            return {
                warningmessages:[],
        }
     },
    computed: mapState({
        isMenuVisible: 'isMenuVisible',
        user() {
            return this.$store.state.user
        },
        compan(){
                return this.$store.state.compan
            },
    }),
    methods: {
        
        async loadwarningmessageOpen() {
        const url = `${baseApiUrl}/warningmessagescompanyopen/${this.compan.id}`
        await    axios(url).then(res => {
                this.warningmessages = res.data
            })
        },

    },
    async  mounted() {
        await this.loadwarningmessageOpen()
     },
     async created() {
         setInterval(async () => Promise.all([
                                       await this.loadwarningmessageOpen()
                                      ]
                                      )  , 1 * 30000);
    }
}
</script>

<style>
.aside.menu-area {
    background-color: #0fdfdf;
    box-shadow: 2px 0 10px 0 rgba(0, 0, 0, 0.12),
        2px 0 15px 0 rgba(0, 0, 0, 0.09);
}
.menu a {
    display: block;
    text-decoration: none;
    color: #fff;
    font-weight: 310;
    padding: 5px;
    font-size: 0.9rem;
    background: #2c3e50;
}

.menu a:hover {
    background: linear-gradient(135deg, #0d698a 0%, #98c9c2 100%);
    color: #fff;
    text-decoration: none;
}

.menu i {
    color: #fff;
    font-size: 1rem;
}
.menu-area {
    background: #2c3e50;
}

.menu button {
    font-size: 0.9rem;
    border: none;
    display: block;
    color: #fff;
    font-weight: 310;
    padding: 5px;
    font-size: 0.9rem;
    background: #2c3e50;
}

.b-sidebar-body {
    background: #2c3e50;
    padding: 10px;
}

.b-sidebar-body i {
    color: #fff;
    font-size: 1rem;
}

.b-sidebar-body a {
    display: block;
    text-decoration: none;
    color: #fff;
    font-weight: 310;
    padding: 5px;
    font-size: 0.9rem;
}

.b-sidebar-body a:hover {
    background: linear-gradient(135deg, #0d698a 0%, #98c9c2 100%);
    color: #fff;
    text-decoration: none;
}
</style>
